import { makeStyles, Grid } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import SWLink from '../_components/SWLink'
import ContentFeature from '../_components/ContentFeature'

const useStyles = makeStyles<Theme, TopColorProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'TopColor' }
)

export interface TopColorProps {
  classes?: StyleClasses<typeof useStyles>
}

function TopColor(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentFeature
        title="Our Top Colors"
        description={
          <>
            An incredibly versatile range <br />
            of whites and neutrals from <br />
            our experts to suit any style.
          </>
        }
        cta={
          <Grid item xs={12}>
            <SWLink
              href="https://www.sherwin-williams.com/en-us/color/color-collections/top-50-colors?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=most-popular-colors"
              label="EXPLORE OUR COLLECTION"
              theme="dark"
              style={{ width: '100%' }}
            />
          </Grid>
        }
        colorTileA={{
          color: '#C4B9A3',
          colorCode: '9965',
          colorName: 'Peace of Mind',
          darkText: true
        }}
        colorTileB={{
          color: '#F0ECE2',
          colorCode: '7551',
          colorName: 'Greek Villa',
          darkText: true
        }}
        image={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/our-top-colors.png'}
        imageAlt="Sherwin-Williams top colors"
      />
    </div>
  )
}

export default TopColor
